import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { css as r } from '../../../../node_modules/@lit/reactive-element/css-tag.js';

var css_248z = r`.account-access-mobile{display:flex;flex-direction:column;gap:16px;max-width:767px;padding:4px 16px 10px}`;

export { css_248z as default };
